import { create } from 'zustand';
import { MAX_PHOTOS_PER_VISIT, nextVisitState, } from '@fieldvision/contracts';
export const useVisitSession = create((set, get) => ({
    visitId: null,
    state: null,
    photoCount: 0,
    start: (visitId) => set({ visitId, state: 'OPEN', photoCount: 0 }),
    /**
     * Adopt the state the SERVER reports, for a session this tab did not start.
     *
     * Distinct from `start`, which means "a check-in just happened here, so the
     * state is OPEN by definition". Re-entering an existing visit used to call
     * `start`, which asserted OPEN over a visit the server had already moved to
     * SUBMITTED — the client half of the FR-07 oddity quietly disagreeing with the
     * server about whether data had been sent. This store deliberately keeps no
     * persisted copy of that (the server is the authority); this is how the
     * authoritative answer gets in.
     */
    hydrate: (visitId, state, photoCount) => set({ visitId, state, photoCount }),
    /** Returns false and changes nothing when the transition is illegal. */
    apply: (event) => {
        const { state, photoCount } = get();
        if (state === null)
            return false;
        const next = nextVisitState(state, event);
        if (next === null)
            return false;
        set({
            state: next,
            photoCount: event === 'ADD_PHOTO' ? photoCount + 1 : photoCount,
        });
        return true;
    },
    canAddPhoto: () => {
        const { state, photoCount } = get();
        if (state === null)
            return false;
        // FR-04 caps a visit at MAX_PHOTOS_PER_VISIT; the server enforces it too.
        return photoCount < MAX_PHOTOS_PER_VISIT && nextVisitState(state, 'ADD_PHOTO') !== null;
    },
    reset: () => set({ visitId: null, state: null, photoCount: 0 }),
}));
//# sourceMappingURL=visit-session.store.js.map